import React from 'react';
import PropTypes from 'prop-types';
import CreditCard from '../../../common/CreditCard';
import ChargeModalButton from './ChargeModalButton';
import enterCcNumberImage from '../../../../../images/enter-cc-number.svg';

const CardChargeButton = ({ open, disabled, card }) => (
  <ChargeModalButton onClick={open} disabled={disabled} image={enterCcNumberImage} data-automation-id="button:chargeCC">
    Card Entry
    <CreditCard
      className="u-faded u-type--light u--mt-- u--mb"
      size="small"
      display-if={card}
    >
      {card}
    </CreditCard>
  </ChargeModalButton>
);
CardChargeButton.propTypes = {
  open: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  card: PropTypes.shape({
    last4: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
  }),
};
CardChargeButton.defaultProps = {
  card: null,
};

export default CardChargeButton;
